"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customListener = exports.listener = exports.CustomListener = exports.Listener = exports.useCustomListener = exports.useListener = void 0;
const react_1 = __importDefault(require("react"));
const widget_1 = require("../basics/widget");
// Hooks
const useListener = (e, callback, options, deps) => {
    react_1.default.useEffect(() => {
        window.addEventListener(e, callback, options);
        return () => window.removeEventListener(e, callback, options);
    }, deps);
};
exports.useListener = useListener;
const useCustomListener = (e, callback, options, deps) => {
    react_1.default.useEffect(() => {
        window.addEventListener(e, callback, options);
        return () => window.removeEventListener(e, callback, options);
    }, deps);
};
exports.useCustomListener = useCustomListener;
// Components
const Listener = (props) => {
    (0, exports.useListener)(props.eventName, props.callback, props.options, props.deps);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Listener = Listener;
const CustomListener = (props) => {
    (0, exports.useCustomListener)(props.eventName, props.callback, props.options, props.deps);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.CustomListener = CustomListener;
// Widgets
const listener = (eventName, additionalCallback, options, deps) => (0, widget_1.fromJSX)((setState) => (react_1.default.createElement(exports.Listener, { callback: (e) => {
        if (additionalCallback !== undefined)
            additionalCallback(e);
        setState(e);
    }, eventName: eventName, options: options, deps: deps })));
exports.listener = listener;
const customListener = (eventName, additionalCallback, options, deps) => (0, widget_1.fromJSX)((setState) => (react_1.default.createElement(exports.CustomListener, { callback: (e) => {
        if (additionalCallback !== undefined)
            additionalCallback(e);
        setState(e);
    }, eventName: eventName, options: options, deps: deps })));
exports.customListener = customListener;
